/**
 * en-US catalogue. PROVISIONAL — minor copy localisation from en-GB
 * (drop-off vs. drop off, vaccinations vs. shots, etc. kept conservative).
 * Review by a US-English speaker before any US tenant goes live.
 */

import type { TranslationMap } from '../i18n';

export const EN_US: TranslationMap = {
  common: {
    save: 'Save changes',
    saving: 'Saving…',
    saved: 'Changes saved.',
    cancel: 'Cancel',
    confirm: 'Confirm',
    loading: 'Loading…',
    error_generic: 'Something went wrong. Please try again.',
    sign_in: 'Sign in',
    sign_out: 'Sign out',
    back: 'Back',
    next: 'Next',
    yes: 'Yes',
    no: 'No',
    close: 'Close',
    open: 'Open',
    optional: 'Optional',
    required: 'Required',
  },

  nav: {
    home: 'Home',
    bookings: 'Reservations',
    pets: 'Pets',
    profile: 'Profile',
    payments: 'Payments',
    credits: 'Credits',
    packs: 'Packages',
    notifications: 'Notifications',
    privacy: 'Privacy',
    book_now: 'Book now',
    your_account: 'Your account',
  },

  account_home: {
    greeting: 'Hi {{ name }}',
    greeting_anonymous: 'Welcome',
    upcoming_bookings: 'Upcoming reservations',
    no_upcoming: 'No upcoming reservations — book a stay or a daycare day.',
    your_pets: 'Your pets',
    no_pets: "We don't have any pets on file for you yet.",
    quick_actions: 'Quick actions',
  },

  bookings: {
    page_title: 'Your reservations',
    upcoming: 'Upcoming',
    past: 'Past',
    cancelled: 'Canceled',
    starts: 'Starts',
    ends: 'Ends',
    pet: 'Pet',
    service: 'Service',
    total: 'Total',
    balance_due: 'Balance due',
    status: 'Status',
    view_details: 'View details',
    cancel_booking: 'Cancel reservation',
    request_refund: 'Request refund',
    pay_balance: 'Pay balance',
    photos: 'Photos',
    no_photos: 'No photos yet — staff will post updates here during the stay.',
    booking_id: 'Reservation #',
  },

  pets: {
    page_title: 'Your pets',
    add_pet: 'Add a pet',
    no_pets: 'You have no pets on file yet.',
    breed: 'Breed',
    species: 'Species',
    weight: 'Weight',
    date_of_birth: 'Date of birth',
    microchip: 'Microchip',
    vaccinations: 'Vaccinations',
    notes: 'Notes',
    upload_photo: 'Upload a photo',
    vet_sharing: 'Vet sharing',
  },

  profile: {
    page_title: 'Profile',
    section_eyebrow: 'Your account',
    name_label: 'Name',
    name_placeholder: 'Your name',
    phone_label: 'Phone',
    email_label: 'Email',
    email_help: 'Contact us to change your email.',
    account_label: 'Account:',
    language_label: 'Language',
    language_help: 'Choose the language for your account and notifications.',
    save_failed: 'Could not save changes. Please try again.',
    load_failed: 'Could not load profile. Please try again.',
  },

  payments: {
    page_title: 'Payments',
    history: 'Payment history',
    no_payments: 'No payments yet.',
    amount: 'Amount',
    paid_on: 'Paid on',
    method: 'Method',
    reference: 'Reference',
    receipt: 'Receipt',
    add_payment_method: 'Add a payment method',
  },

  sign_in: {
    page_title: 'Sign in to {{ accountName }}',
    page_title_default: 'Sign in',
    email_label: 'Email address',
    send_link: 'Send sign-in link',
    sending: 'Sending…',
    link_sent_title: 'Check your inbox',
    link_sent_body: "We've sent a sign-in link to {{ email }}. It will expire in 15 minutes.",
    consume_loading: 'Signing you in…',
    consume_failed: "We couldn't sign you in. The link may have expired.",
    back_to_sign_in: 'Back to sign in',
  },
};
